<script lang="ts">
  import type { HeroFormStoryblok } from '$types/bloks';

  import { cn } from '$lib/utils/tailwind';

  import Title from '$components/title.svelte';
  import HubspotForm from '$components/hubspot-form.svelte';
  import CalendlyForm from '$components/calendly-form.svelte';
  import FeatureItem from '$components/benefits/feature-item.svelte';
  import BookADemoIllustration from '$components/heros/hero-form/assets/book-a-demo.webp';

  export let blok: HeroFormStoryblok;
  $: ({ title, embed, items } = blok);
</script>

<section class="relative isolate flex h-full w-full overflow-hidden">
  <div class="relative mx-auto flex w-full px-20 pb-80 pt-80 lg:px-48 xl:max-w-container">
    <div class="grid w-full gap-48 lg:grid-cols-2 lg:gap-x-48">
      {#if title?.[0]}
        <Title
          data={title[0]}
          class="w-full lg:max-w-[648px]"
          descriptionClass="max-w-[531px]"
          titleClass="lg:text-4xl"
        />
      {/if}

      {#if embed?.length}
        {@const { component, form, calendar } = embed[0]}
        <div
          class={cn(
            'h-fit min-h-[800px] w-full max-w-[514px] rounded-4xl border border-highlight-foreground border-opacity-24 bg-[#EBEBF7] p-20 lg:row-span-2 lg:ml-auto lg:min-w-[514px]',
            component === 'calendly' && 'h-[930px] lg:h-[930px]'
          )}
        >
          {#if component === 'hubspot-form' && form}
            <HubspotForm {form} />
          {:else}
            <CalendlyForm {calendar} />
          {/if}
        </div>
      {/if}

      {#if items?.length}
        <div class="flex w-full flex-col gap-32 md:flex-row lg:mt-48">
          {#each items as item}
            <FeatureItem data={item} class="max-w-[292px] basis-full p-0 lg:p-0" />
          {/each}
        </div>
      {:else}
        <div class="lg:mt-0">
          <img
            alt=""
            src={BookADemoIllustration}
            role="presentation"
            class="aspect-auto h-full w-full max-w-[770px] flex-shrink-0 translate-y-20 lg:-translate-x-60"
          />
        </div>
      {/if}
    </div>
  </div>
</section>
